<!--
 * @Description: 
 * @Author: 诺
 * @Date: 2021-12-20 11:22:43
 * @LastEditors: 诺
 * @LastEditTime: 2022-11-11 16:22:10
-->

<template>
  <div
    class="boxMian"
    v-if="configInfo"
    :style="{
      backgroundColor: configInfo.backgroundColour,
    }"
  >
    <div class="page-wrapper" :style="{ backgroundImage: `url('${imgHost}page/bg.png')` }">
      <div class="title title1">
        <img  :src="`${imgHost}page/title8.png`"/>
        <img class="tip2" :src="`${imgHost}page/tip2.png`"/>
      </div>
      <div class="title title2">
        <img  :src="`${imgHost}page/title9.png`"/>
        <img class="tip2" :src="`${imgHost}page/tip2.png`"/>
      </div>
      <div  class="title title3">
        <img :src="`${imgHost}page/title10.png`"/>
      </div>
      <img class="tip1" :src="`${imgHost}page/tip1.png`"/>
      <div class="countDown">
        <div class="time">{{ hour }}</div>:
        <div class="time" >{{ minute }}</div>:
        <div class="time" >{{ second }}</div>
      </div>

      <img class="shareBtn" :src="`${imgHost}page/shareBtn${isShare?1:2}.png`" @click="showShare"/>
      <img class="shareText" :src="`${imgHost}page/share_text${isShare?1:2}.png`"/>
      <BaseBottom :configInfo="configInfo" />
      <ActBaseBtnHome :bColor="configInfo.buttonBackgroundColour" :textColor="configInfo.buttonTextColour"></ActBaseBtnHome>
    </div>
  </div>
</template>

<script>
import { rgbToRgba } from "./components/util";

export default {
  components: {},
  props: {},

  data() {
    return {
      configInfo:null,
      day: "00",
      hour: "00",
      minute: "00",
      second: "00",
      isShare:null,
      remainingTime:0
    };
  },

  mounted() {
    this.configInfo = this.$configInfo;
    if (this.$configInfo.shareSwitch!= 1) {
      this.$wx.hideOptionMenu();
    }
    this.getTodayShareCount()
    this.initData();
  },
  methods: {
    // 
    async getTodayShareCount() {
      let url = this.$apizt.action.getTodayShareCount;
      const { data, result } = await this.$httpzt.requestRestFul(url, {});
      if (result) {
        this.isShare=data
      }
    },
    initData(){

      var dt = new Date();
      let m=dt.getMonth()+1;//获得月份
      let d=dt.getDate()+1;//获取日
      let y=dt.getFullYear(); //获取年(四位)
      
      this.remainingTime = Math.ceil((new Date(`${y}/${m}/${d} 00:00:00`).getTime()- new Date().getTime()) / 1000); // 剩余多少秒 活动倒计时
      if (this.remainingTime > 0) {
        setInterval(() => {
          this.remainingTime--;
          this.countDown();
        }, 1000);
      }
    },
    countDown(time) {
      // let _totalSecond = Math.ceil(this.remainingTime / 1000);
      let _totalSecond = Math.ceil(this.remainingTime);
      let day = Math.floor(_totalSecond / (24 * 60 * 60));
      let hour = Math.floor((_totalSecond % (24 * 60 * 60)) / (60 * 60));
      let minute = Math.floor(((_totalSecond % (24 * 60 * 60)) % (60 * 60)) / 60);
      let second = Math.floor(((_totalSecond % (24 * 60 * 60)) % (60 * 60)) % 60);

      if (day < 10) {
        day = "0" + day;
      }
      if (hour < 10) {
        hour = "0" + hour;
      }
      if (minute < 10) {
        minute = "0" + minute;
      }
      if (second < 10) {
        second = "0" + second;
      }
      this.$nextTick(() => {
        this.day = day;
        this.hour = hour;
        this.minute = minute;
        this.second = second;
      });
    },
    showShare() {
      let text = {
        text1: "点击",
        text2: "右上角",
        text3: "推荐好友参与",
        text4: "让你和TA都获得金喜，",
        text5: "快去消息列表看看",
        text6: "会有什么神奇的事情发生吧！",
      };
      // if (this.configInfo.helpOnOrOff == 1) {
      //   text.text2 = `每日分享好友，最多获得${this.configInfo.helpTimesUpperLimit}次机会，`;
      //   let helpRule = JSON.parse(this.configInfo.helpRule);
      //   text.text3 = `每助力${helpRule.helpTimes}人，可获得${helpRule.getLotteryTimeWithHelp}次机会。`;
      // }
      this.$modal.share.alert(text).then((data) => {
        if (data == "save") {
          console.log(this.configInfo.shareImg);
          this.$modal.poster.alert({
            gameBg: this.configInfo.shareImg, //分享截图背景图
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
div {
  position: relative;
  box-sizing: border-box;

  img {
    width: 100%;
  }
}

.boxMian {
  width: 100%;
  min-height: 100vh;

  .page-wrapper {
    position: relative;
    width: 100%;
    min-height: 100vh;
    overflow-x: hidden;
    background-position: top center;
    background-repeat: no-repeat;
    background-size: 100% auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    .title{
      margin-bottom:30px;
      margin-left:18px;
      &.title1{
        width:290px
      }
      &.title2{
        width:327px
      }
      &.title3{
        width:346px
      }
      .tip2{
        width:70px;
        position: absolute;
        right:-25px;
        top:-31px;
      }
    }
   
    .tip1{
      width:135px;
      margin:3px auto 0;
    }
    
    .countDown {
      font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 8px;
      font-size: 20px;
      text-align: center;
      color:#fff;

      .time {
        height: 28px;
        border-radius: 4px;
        line-height: 28px;
        margin: 0 5px;
        padding: 0 7px;
        background-color: #FC534C;
      }
    }
    .shareBtn{
      width: 128px;
      margin:24px auto 0;
    }
    .shareText{
      width: 120px;
      margin:18px auto 0;
    }
  }

}
</style>
